<div class="genie-page">
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" alt="Go back" />
      </div>
      <p class="genie-page-title">{{ 'Shipping Providers' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Connect shipping providers and manage merchant delivery credentials.' | translate }}</p>
    </div>
  </div>

  <div class="integrations-grid">
    <app-aramex-provider
      [projectId]="projectId"
      [isOpen]="activePanelType === 'aramex'"
      (openPanel)="openPanel('aramex')"
      (closePanel)="closePanel()"
      (saved)="loadAllProviders()">
    </app-aramex-provider>

    <app-dhl-provider
      [projectId]="projectId"
      [isOpen]="activePanelType === 'dhl'"
      (openPanel)="openPanel('dhl')"
      (closePanel)="closePanel()"
      (saved)="loadAllProviders()">
    </app-dhl-provider>

    <app-smsa-provider
      *ngIf="isGccCompany"
      [projectId]="projectId"
      [isOpen]="activePanelType === 'smsa'"
      (openPanel)="openPanel('smsa')"
      (closePanel)="closePanel()"
      (saved)="loadAllProviders()">
    </app-smsa-provider>

    <app-aymakan-provider
      *ngIf="isSaudiCompany"
      [projectId]="projectId"
      [isOpen]="activePanelType === 'aymakan'"
      (openPanel)="openPanel('aymakan')"
      (closePanel)="closePanel()"
      (saved)="loadAllProviders()">
    </app-aymakan-provider>
  </div>
</div>

<div class="panel-overlay" *ngIf="activePanelType" (click)="closePanel()"></div>
